<template>
	<div class="invite modal">
		<div class="modal-wrap">
			<div class="modal-inner">
				<h2 class="modal-title">{{ title }}<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">
					<form class="form" @submit.prevent="saveSettings">

						<div class="invite-input-wrap-wrap">

							<div class="invite-input-wrap">
								<FormInput
									type="text"
									label="Their First Name"
									v-model="info.firstName"
									name="name"
									:errors="errors"
									@has-internal-errors="hasInternalErrors"
									:disabled="id !== '' ? 'disabled' : false"
								/>
							</div>
							<div class="invite-input-wrap">
								<FormInput
									type="text"
									label="Their Last Name"
									v-model="info.lastName"
									name="name"
									:errors="errors"
									@has-internal-errors="hasInternalErrors"
									:disabled="id !== '' ? 'disabled' : false"
								/>
							</div>

						</div>

						<div class="invite-input-wrap">
							<FormInput
								type="email"
								label="Their Email"
								v-model="info.email"
								name="email"
								:errors="errors"
								@has-internal-errors="hasInternalErrors"
								:disabled="id !== '' ? 'disabled' : false"
							/>
						</div>

						<h4>Global Access?</h4>

						<div>
							<Switcher v-model="info.readOnly" :sameColour="true" class="switcher" switcherLabel2="Read Only" v-if="!info.fullAccess" />

							<Switcher v-model="info.fullAccess" :sameColour="true" class="switcher" switcherLabel2="Full Access" />
						</div>

						<p class="strap" v-if="!info.readOnly&&!info.fullAccess">
							Use global access to give a user access to all current and future projects.
						</p>

						<p class="strap" v-if="info.readOnly&&!info.fullAccess">
							 - User can view ALL projects in Rank Tracking, Data Dive, Insights and Content &amp; Keywords. <br>
							- You can select specific projects for the user to have full access to below.<br>
							- To add new keywords to Content &amp; Keywords, users will need full access set globally.

						</p>

						<p class="strap" v-if="info.fullAccess">
							- User can view ALL projects in Rank Tracking, Data Dive, Insights and Content &amp; Keywords. <br>
							- User can add new keywords in Rank Tracking and Content &amp; Keywords<br>
							- User can add Data Dive to projects (from attached Google Accounts only; not from their own.).
						</p>

						<div v-if="!info.fullAccess">
							<hr />

							<h4 v-html="projectListLoaded ? 'Project Access' : 'Loading projects...'" />

							<p class="strap" v-if="!info.readOnly&&!info.fullAccess">
								Tick to give a user read only access to a project, when ticked you will have the option to grant them full access.
							</p>

							<p class="strap" v-if="info.readOnly&&!info.fullAccess">
								Select the projects you want the user to have full access to. They will have read only access to all other projects.
							</p>

							<FormInput
								type="checkbox"
								v-model="info.projects"
								:items="projectsProcessed"
								v-if="projectListLoaded"
								:noMarginBottom="true"
							/>
						</div>

						<p class="error" v-if="typeof errors === 'string' && errors !== ''" v-html="errors" />

						<span class="large-button full" @click="sendInvite()" v-html="id !== '' ? 'Update Access' : 'Send Invite'" />
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import { mapMutations, mapState } from "vuex";
	import ApiService from "./../services/api.service";
	import general from "./../utils/general";
	import FormInput from "./Form/Input.vue";
	import Switcher from "./Switcher.vue";
	export default {
		name: "Invite",
		components: {
			FormInput,
			Switcher,
		},
		props: {
			currentProjects: {
				type: Array,
				default: function() {
					return [];
				},
			},
			id: {
				type: String,
				default: "",
			},
			type: {
				type: String,
				default: "",
			},
			firstName: {
				type: String,
				default: "",
			},
			lastName: {
				type: String,
				default: "",
			},
			userEmail: {
				type: String,
				default: "",
			},
			readOnly: {
				type: Boolean,
				default: false,
			},
			fullAccess: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				errors: {},
				info: { projects: this.currentProjects, name: "", email: "" },
				okToSubmit: this.id !== "",
				fetched: false,
			};
		},
		computed: {
			...mapState("general", ["userLevels", "projectList", "projectListLoaded"]),
			accessLevelDescription() {
				if (this.userLevels.length === 1)
					return "By default a user can access all parts of RankCaddy but they cannot add new keywords, there is currently one other access level available...";

				return (
					"By default a user can access all parts of RankCaddy but they cannot add new keywords, " +
					userLevels.length +
					" other access levels are available.."
				);
			},
			title() {
				if (this.id !== "") {
					return "User Access";
				}

				return "Invite User";
			},
			projectsProcessed() {
				let projects = [];

				if (this.projectListLoaded) {
					this.projectList.forEach(
						function(project) {
							if (project.shared) return;

							let name = project.name,
								_id = project._id;

							if (this.info.readOnly) {
								name += " - Full access";
								_id = "full-" + _id;
							}

							projects.push({ _id: _id, label: name });

							if (this.info.projects && this.info.projects.indexOf(project._id) >= 0 && !this.info.readOnly) {
								let higherLevelChecked = false;

								this.userLevels.forEach(
									function(level) {
										let id = level.id + "-" + project._id,
											found = this.info.projects.indexOf(id),
											disabled = false;

										if (found >= 0) {
											if (higherLevelChecked) {
												let p = [...this.info.projects];

												p.splice(found, 1);

												Vue.set(this.info, "projects", p);

												disabled = true;
											} else {
												higherLevelChecked = true;
											}
										} else {
											if (higherLevelChecked) {
												disabled = true;
											}
										}

										projects.push({ _id: id, label: level.label, tabbed: true, disabled: disabled });
									}.bind(this)
								);
							}
						}.bind(this)
					);
				}

				return projects;
			},
		},

		methods: {
			...mapMutations("general", ["updateLoadingText"]),

			sendInvite() {
				if (!this.okToSubmit || !this.info.firstName || !this.info.lastName || !this.info.email) {
					if (!this.info.firstName || !this.info.lastName || !this.info.email) {
						this.$snotify.error("Please enter all fields", "User Access");
					}
					return;
				}

				if (!this.info.readOnly&&!this.info.fullAccess&&!this.info.projects.length) {
					this.$snotify.error("Please select Read Only/Full Access globally or at least 1 project", "User Access");
					return;
				}

				let info = {
					projects: this.info.projects,
					fullAccess: !!this.info.fullAccess,
					readOnly: !!this.info.readOnly,
				};

				if (!!this.id) {
					info.id = this.id;
					info.type = this.type;
				} else {
					info.name = this.info.name;
					info.firstName = this.info.firstName;
					info.lastName = this.info.lastName;
					info.email = this.info.email;
				}

				this.updateLoadingText(this.id ? "Updating access..." : "Sending invite...");

				ApiService.post("users/invite", info)
					.then(
						function(info) {
							general.apiResponse(
								info,
								function(info) {
									this.info.id = "";
									this.info.firstName = "";
									this.info.lastName = "";
									this.info.email = "";
									this.info.projects = [];
									this.info.readOnly = false;
									this.info.fullAccess = false;
									this.$emit("close-invite", true);
									this.updateLoadingText();
								}.bind(this)
							);
						}.bind(this)
					)
					.catch(
						function(error) {
							Vue.set(this, "errors", error.response.data.error);
						}.bind(this)
					);
			},

			close($event) {
				$event.preventDefault();

				this.info.id = "";
				this.info.firstName = "";
				this.info.lastName = "";
				this.info.email = "";
				this.info.projects = [];
				this.info.readOnly = false;
				this.info.fullAccess = false;

				this.$emit("close-invite");
			},
			hasInternalErrors(a) {
				if (typeof this.errors[a.name] !== "undefined") delete this.errors[a.name];

				if (a.error) this.errors[a.name] = a.error;

				this.okToSubmit = true;

				Object.keys(this.errors).forEach(
					function(error) {
						this.okToSubmit = this.errors[error].error !== false ? false : this.okToSubmit;
					}.bind(this)
				);
			},
		},
		created () {
			let info = {
				projects: []
			};
			if (this.id !== "") {
				info.name = this.userName;
				info.email = this.userEmail;
				info.firstName = this.firstName;
				info.lastName = this.lastName;
				info.fullAccess = this.fullAccess;
				info.readOnly = this.readOnly;
				info.projects = this.currentProjects;
			}
			Vue.set(this, "info", info);
		}
	};
</script>

<style lang="less" scoped>
	.modal {
		&.invite {
			.modal-inner {
				max-width: 550px;
				.invite-input-wrap {
					margin-bottom: 0px;
				}
				.strap {
					padding: 0;
					margin: 0 0 8px;
					font-size: 14px;
				}
			}
		}
	}
	@media screen and (min-width: 1024px) {
		.modal {
			&.invite {
				.modal-inner {
					.invite-input-wrap-wrap {
						display: flex;
						justify-content: space-between;
						.invite-input-wrap {
							flex: 0 0 48%;
							width: 48%;
						}
					}
				}
			}
		}
	}
</style>
<style lang="less">
	.modal {
		&.invite {
			.modal-inner {
				.form {
					.checkbox-wrap {
						label {
							font-size: 14px;
						}
					}
				}
			}
		}
	}
</style>
